import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { access, apiErrorSchema } from './schemas/common.js';
import { agentLanguageSchema, agentSettingsInputSchema, agentSettingsSchema, agentToneSchema, } from './schemas/agent.js';
const c = initContract();
export const agentContract = c.router({
    settings: {
        method: 'GET',
        metadata: access('viewer'),
        path: '/agent/settings',
        summary: 'How the agent answers, and the choices an admin has',
        responses: {
            200: z.object({
                settings: agentSettingsSchema,
                models: z.array(z.string()),
                languages: z.array(agentLanguageSchema),
                tones: z.array(agentToneSchema),
            }),
        },
    },
    save: {
        method: 'PUT',
        metadata: access('admin'),
        path: '/agent/settings',
        summary: 'Change the tone, operator notes, reply language or answer model',
        body: agentSettingsInputSchema,
        responses: {
            200: z.object({ settings: agentSettingsSchema }),
            400: apiErrorSchema.extend({ problems: z.array(z.string()) }),
        },
    },
});
//# sourceMappingURL=agent.contract.js.map